export default "__VITE_PUBLIC_ASSET__f651ecd7__"